import React from 'react';

type Props = {
  header: string;
  seoText: string;
  embedded?: boolean;
  divider?: boolean;
};

export function SeoTextBlockInternal({ header, seoText, embedded = false, divider = true }: Props) {
  if (!header && (!seoText || seoText.trim() === '<p></p>')) {
    return null;
  }

  return (
    <div
      className={
        embedded
          ? divider
            ? 'border-t border-primary-stroke-day pt-6 md:pt-8'
            : ''
          : 'mt-[16px] md:mt-[40px] rounded-[16px] bg-light-green-bg p-[20px] md:p-[40px]'
      }
    >
      {header && <h2 className='text-[18px] mb-[20px] font-semibold'>{header}</h2>}

      <div className='no-tailwind '>
        <div dangerouslySetInnerHTML={{ __html: seoText }}></div>
      </div>
    </div>
  );
}

export const SeoTextBlock = React.memo(SeoTextBlockInternal);
